import React from 'react';
import IdentityViewer from '../components/digital-identity/IdentityViewer';

const DigitalIdentityView = () => {
  return <IdentityViewer />;
};

export default DigitalIdentityView;
